import {initDbStore} from "./initDb";
import moment from "moment";

const tdNewsStoreName = 'news';

export async function saveTdNews(news) {
  const db = await initDbStore();

  if (news.length > 0) {
    await db.clear(tdNewsStoreName);

    await Promise.all(
      news.map(item => {
        return saveTdNewsItem(item);
      })
    )
  }

  return true;
}

async function saveTdNewsItem(news) {
  const db = await initDbStore();

  try {
    db.add(tdNewsStoreName, {
      ...news,
      createdAt: moment().format('x'),
      updatedAt: moment().format('x'),
    });

    return true;
  } catch (e) {
    console.log(e);
  }

  return false;
}

export async function getTdNews() {
  const db = await initDbStore();

  return db.getAll('news');
}
